import { z } from 'zod';

export const B2bCashSourceValues = [
  'voluntary_deposit',
  'participation',
  'profit_sharing',
  'value_sharing_bonus',
  'unused_vacation_days',
  'ccb_matured_election',
] as const;
export const ZodB2bCashSource = z.enum(B2bCashSourceValues);
export type B2bCashSource = z.TypeOf<typeof ZodB2bCashSource>;

export const B2bUserFlagValues = [
  'pep',
  'vulnerable',
  'vip',
  'guardianship',
  'trusteeship',
  'fraud_suspicion',
  'country_under_surveillance',
  'high_risk_country',
  'insider',
  'atd',
  'eole_finance',
  'bailiff',
  'pledging',
  'administrative',
  'eckert',
  'pnd',
] as const;
export const ZodB2bUserFlag = z.enum(B2bUserFlagValues);
export type B2bUserFlag = z.TypeOf<typeof ZodB2bUserFlag>;
